import React from 'react';
import {useFormContext, Controller} from 'react-hook-form';
import Select from 'react-select';

const ListPrinterType = ({required = false, onChange}) => {
  const printerTypes = [
    {label: 'GTX', value: 'gtx'},
    {label: 'GTXpro', value: 'gtxpro'},
    {label: 'GTXpro Bulk', value: 'gtxprobulk'},
    {label: 'GTX300NC', value: 'gtx300nc'},
    {label: 'GTX600', value: 'gtx600'},
    {label: 'GTX600SB', value: 'gtx600sb'},
    {label: 'GTX600NBA', value: 'gtx600nba'},
    {label: 'GT-341', value: 'gt341'},
    {label: 'GT-361', value: 'gt361'},
    {label: 'GT-381', value: 'gt381'},
    {label: 'WF1-L640', value: 'wf1l640'},
    {label: 'DTRX100', value: 'dtrx100'},
  ];

  const {formState: {errors}, control} = useFormContext();

  return (
    <>
      <Controller
        name="printer_type"
        control={control}
        rules={{required: required ? 'Please select a printer type' : false}}
        render={({field}) => (
          <Select
            className={'react-select-container'}
            {...field}
            options={printerTypes}
            isClearable
            placeholder="Select printer type"
            onChange={(selected) => {
              field.onChange(selected);
              if (onChange) onChange(selected || null);
            }}
          />
        )}
      />
      {errors?.printer_type && (
        <p className="text-danger"><small>{errors.printer_type.message}</small></p>
      )}
    </>
  );
};

export default ListPrinterType;
